import { type IPoint } from 'fabric/fabric-impl';
import type Canvas from '../objects/Canvas';
import Wireframe from '../objects/Wireframe';
import DraggableBrush from './DraggableBrush';
import type StylusWireframe from './StylusWireframe';

// Brush for drawing frame objects.
class WireframeDrawingBrush extends DraggableBrush {
  canvas: Canvas;
  stylus: StylusWireframe;
  dragHandle: string;

  constructor(canvas: Canvas, stylus: StylusWireframe) {
    super();
    this.canvas = canvas;
    this.stylus = stylus;
    this.dragHandle = 'br';
  }

  async startDragging(pointer: IPoint) {
    return this._createWireframe(pointer);
  }

  onMouseDown(pointer, eventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return;
    }

    this.canvas.controller.actionSetStylusMenu(null);

    this._createWireframe(pointer);

    this.canvas.controller.undoManager.completeUndoGroup();
    this.canvas.requestRenderAll();
  }

  onMouseMove() {}

  onMouseUp() {
    this.stylus.drawingComplete();
    this.canvas.controller.actionShowObjectToolbar();

    // So we stop drawing.
    return false;
  }

  _createObject(options): Wireframe {
    const controller = this.canvas.controller;
    return new Wireframe({
      controller,
      canvas: controller.canvas,
      ...controller.defaultsManager.for('wireframe', this.stylus.wireframeName),
      ...options,
    });
  }

  _createWireframe(pointer) {
    const options = {
      left: pointer.x,
      top: pointer.y,
    };

    const wireframe = this._createObject({
      wireframeName: this.stylus.wireframeName,
      ...options,
    });

    this.canvas.controller.addToCanvas(wireframe);
    this.canvas.setActiveObject(wireframe);
    // Hide toolbar we showed when setting the active object.
    this.canvas.controller.actionHideObjectToolbar();
    return wireframe;
  }

  _render() {}
}

export default WireframeDrawingBrush;
